import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { UnsafeAction } from "./UnsafeAction"

@Injectable()
export class MessageActions {
	static DISPLAY_MESSAGE = '[MESSAGE] display message';
	displayMessage(message: string, type:string): UnsafeAction{
		return {
			type:MessageActions.DISPLAY_MESSAGE,
			payload: {message:message,type:type}
		}
	}

	static REMOVE_MESSAGE = '[MESSAGE] remove message';
	removeMessage(id: number) {
		return {
			type: MessageActions.REMOVE_MESSAGE,
			payload:id
		}
	}

	static CLEAR_MESSAGES = '[MESSAGE] remove all message';
	clearMessages() {
		return {
			type: MessageActions.CLEAR_MESSAGES
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/actions/message.actions.ts